// removed by extract-text-webpack-plugin
module.exports = {"page":"src-pages-style----general-module---page---1osdA overflow-hidden"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/style/general.module.css
// module id = 761
// module chunks = 35783957827783 247189622667744